// extracted by mini-css-extract-plugin
export default {"box":"CountCreditsBtn_box__dqc2N","counter":"CountCreditsBtn_counter__8xCVy","btn":"CountCreditsBtn_btn__efPpU","icon":"CountCreditsBtn_icon__kOj-1"};